import Barrier from '@/services/api/barrier.js';

export default {
  namespaced: true,
  state: {
    barriers: [],
    barrier: {},
    barrierEdit: {},
  },
  getters: {
    barriers: state => state.barriers,
    barrier: state => state.barrier,
    barrierEdit: state => state.barrierEdit,
  },
  mutations: {
    setBarriers: (state, clients) => {
      state.barriers = clients;
    },
    setBarrier: (state, client) => {
      state.barrier = client;
    },
    setBarrierEdit: (state, client) => {
      state.barrierEdit = client;
    },
    setBarrierSnapshot: (state, snapshot) => {
      if (state.barrier && Object.keys(state.barrier).length) {
        state.barrier.snapshot = snapshot;
      }
    },
  },
  actions: {
    loadAllBarriers (state, options = {}) {
      return new Promise((resolve, reject) => {
        Barrier.loadAllBarriers(options)
          .then(({ data }) => {
            state.commit('setBarriers', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getBarrier (state, { id, includes = [] }) {
      return new Promise((resolve, reject) => {
        Barrier.getBarrier(id, includes)
          .then(({ data }) => {
            state.commit('setBarrier', data.barrier);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getBarrierInfoEdit (state, { id }) {
      return new Promise((resolve, reject) => {
        Barrier.getBarrierInfoEdit(id)
          .then(({ data }) => {
            state.commit('setBarrierEdit', data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getSipHistory (state, id) {
      return new Promise((resolve, reject) => {
        Barrier.getSipHistory(id)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch(e => reject(e));
      });
    },
    exportSipHistoryCsvBarrier (state, id) {
      return new Promise((resolve, reject) => {
        Barrier.exportSipHistoryCsvBarrier(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    newBarrier (state, params) {
      return new Promise((resolve, reject) => {
        Barrier.newBarrier(params)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    updateBarrier (state, { id, params }) {
      return new Promise((resolve, reject) => {
        Barrier.updateBarrier(id, params)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    removeBarrier (state, { id }) {
      return new Promise((resolve, reject) => {
        Barrier.removeBarrier(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    addBarrierDoorphone (state, { barrierId, doorphones }) {
      return new Promise((resolve, reject) => {
        Barrier.addBarrierDoorphone(barrierId, { doorphones })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    removeBarrierDoorphone (state, { barrierId, doorphoneId }) {
      return new Promise((resolve, reject) => {
        Barrier.removeBarrierDoorphone(barrierId, doorphoneId)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    openBarrier (state, { id, doornum }) {
      return new Promise((resolve, reject) => {
        Barrier.openBarrier(id, doornum)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getCheckCamerasBarrier (state, { id }) {
      return new Promise((resolve, reject) => {
        Barrier.getCheckCamerasBarrier(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getSipStatus (state, id) {
      return new Promise((resolve, reject) => {
        Barrier.getSipStatus(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    updateSnapshot (state, id) {
      return new Promise((resolve, reject) => {
        Barrier.updateSnapshot(id)
          .then(({ data }) => {
            if (data.snapshot != null) {
              state.commit('setBarrierSnapshot', data.snapshot);
            }
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getStatusCondition (state, { id }) {
      return new Promise((resolve, reject) => {
        Barrier.getStatusCondition(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    blockBarrier (state, id) {
      return new Promise((resolve, reject) => {
        Barrier.blockBarrier(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    unlockBarrier (state, id) {
      return new Promise((resolve, reject) => {
        Barrier.unlockBarrier(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getJournalGrzOpen (state, { id, startDate, endDate, sort, carNumbers }) {
      return new Promise((resolve, reject) => {
        Barrier.getJournalGrzOpen(id, startDate, endDate, sort, carNumbers)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getImageJournalGrz (state, { id, dateTime }) {
      return new Promise((resolve, reject) => {
        Barrier.getImageJournalGrz(id, dateTime)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    downloadListCarsNumbers (state, { id }) {
      return new Promise((resolve, reject) => {
        Barrier.downloadListCarsNumbers(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    updateCoordsBarrier (state, { id, barrier }) {
      return new Promise((resolve, reject) => {
        Barrier.updateCoordsBarrier(id, barrier)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    importCarNumbersByCsv (state, { id, formData, actionShould }) {
      return new Promise((resolve, reject) => {
        Barrier.importCarNumbersByCsv(id, formData, actionShould)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    updateCarNumber (state, { id, data }) {
      return new Promise((resolve, reject) => {
        Barrier.updateCarNumber(id, data)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    addAdditionalAddress (state, { id, address }) {
      return new Promise((resolve, reject) => {
        Barrier.addAdditionalAddress(id, address)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    removeAdditionalAddress (state, { idBarrier, idAddress }) {
      return new Promise((resolve, reject) => {
        Barrier.removeAdditionalAddress(idBarrier, idAddress)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    makeCall (state, { phone }) {
      return new Promise((resolve, reject) => {
        Barrier.makeCall(phone)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    exportCsv (state) {
      return new Promise((resolve, reject) => {
        Barrier.exportCsv()
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getWhitePhoneNumbers (state, { barrierId }) {
      return new Promise((resolve, reject) => {
        Barrier.getWhitePhoneNumbers(barrierId)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    createWhitePhoneNumber (state, { barrierId, params }) {
      return new Promise((resolve, reject) => {
        Barrier.createWhitePhoneNumber(barrierId, params)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateWhitePhoneNumber (state, { barrierId, whitePhoneNumberId, params }) {
      return new Promise((resolve, reject) => {
        Barrier.updateWhitePhoneNumber(barrierId, whitePhoneNumberId, params)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    deleteWhitePhoneNumber (state, { barrierId, whitePhoneNumberId }) {
      return new Promise((resolve, reject) => {
        Barrier.deleteWhitePhoneNumber(barrierId, whitePhoneNumberId)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    importWhitePhoneNumbers (state, { barrierId, formData }) {
      return new Promise((resolve, reject) => {
        Barrier.importWhitePhoneNumbers(barrierId, formData)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    exportWhitePhoneNumbers (state, { barrierId }) {
      return new Promise((resolve, reject) => {
        Barrier.exportWhitePhoneNumbers(barrierId)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
  },
};
